import { Component } from 'react'

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { error: null }
  }

  static getDerivedStateFromError(error) {
    return { error }
  }

  componentDidCatch(error, info) {
    console.error('Mayar app error:', error, info)
  }

  render() {
    if (this.state.error) {
      return (
        <div className="flex min-h-screen flex-col items-center justify-center bg-background px-6 text-center">
          <h1 className="mb-3 text-2xl font-bold text-primary">Something went wrong</h1>
          <p className="mb-6 max-w-md text-sm text-text/70">
            The page failed to load. Try a hard refresh (Cmd+Shift+R or Ctrl+Shift+R).
            If the problem continues, contact the site administrator.
          </p>
          <button
            type="button"
            onClick={() => window.location.reload()}
            className="rounded-lg bg-primary px-5 py-2.5 text-sm font-semibold text-white"
          >
            Reload page
          </button>
        </div>
      )
    }

    return this.props.children
  }
}
